import { useNavigate } from "react-router-dom";
import Layout from "../../components/global/layout";
import { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import { useParams } from "react-router-dom";
import loader from "../../methods/loader";
import { Tooltip } from "antd";


const ContactDetail = () => {
  const [data, setData] = useState();
  const history = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      getContactDetail();
    }
  }, [id]);

  const getContactDetail = () => {
    loader(true);
    ApiClient.get(`contactUs/detail?id=${id}`).then((res) => {
      if (res.success) {
        setData(res.data);
      }
      loader(false);
    });
  };

  return (
    <>
      <Layout>
        <div className="wrapper_section bg-white shadow-box rounded-lg w-full p-4">
          <div className="flex items-center mb-8">
            <Tooltip placement="top" title="Back">
              <span
                onClick={() => history(-1)}
                className="!px-4 py-2 cursor-pointer flex items-center justify-center rounded-lg shadow-btn hover:bg-[#F3F2F5] border transition-all mr-3"
              >
                <i className="fa fa-angle-left text-lg"></i>
              </span>
            </Tooltip>
            <div>
              <h3 className="text-lg lg:text-2xl font-semibold text-[#111827]">Contact  Detail</h3>
            </div>
          </div>
          <div className="flex flex-col gap-y-6">
            {/* User Name */}
            <div className="col-span-12 md:col-span-6">
              <div className="">
                <p className="flex md:items-center flex flex-col md:flex-row font-semibold capitalize">
                  <span className="inline-flex md:w-96 text-md text-gray-600">Full Name:</span>
                  {data?.fullName}
                </p>
              </div>
            </div>

            {/* User Email */}
            <div className="col-span-12 md:col-span-6">
              <div className="">
                <p className="flex md:items-center flex flex-col md:flex-row font-semibold">
                  <span className="inline-flex md:w-96 text-md text-gray-600">Email:</span>
                  {data?.email}
                </p>
              </div>
            </div>

            {/* Contact Message */}
            <div className="col-span-12 md:col-span-6">
              <div className="">
                <p className="flex md:items-center flex flex-col md:flex-row font-semibold">
                  <span className="inline-flex md:w-96 text-md text-gray-600 shrink-0">Message:</span>
                  <span>{data?.message}</span>
                </p>
              </div>
            </div>

           

            {/* Additional Info (Optional) */}
            {data?.additionalInfo && (
              <div className="col-span-12 md:col-span-6">
                <div className="">
                  <p className="flex md:items-center flex flex-col md:flex-row font-semibold">
                    <span className="inline-flex md:w-96 text-md text-gray-600">Additional Information:</span>
                    <span>{data?.additionalInfo}</span>
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </Layout>
    </>
  );
};

export default ContactDetail;
